import i18next from 'i18next';
import { HMRPlugin } from 'i18next-hmr/plugin';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
const instance = i18next.use(Backend).use(initReactI18next);
if (import.meta.env.DEV && import.meta.hot) {
  instance.use(new HMRPlugin({
    vite: {
      client: true
    }
  }));
}
void instance.init({
  lng: 'en',
  fallbackLng: false,
  ns: ['common', 'validations'],
  fallbackNS: 'common',
  defaultNS: 'common',
  nsSeparator: ':',
  interpolation: {
    escapeValue: false // not needed for React
  },
  backend: {
    requestOptions: {
      cache: 'no-store'
    },
    queryStringParams: {
      v: process.env.NX_PUBLIC_APP_VERSION || 'development'
    }
  },
  react: {
    useSuspense: true
  },
  debug: import.meta.env.DEV
});

// Keep custom formatters in sync with apps/backend/src/i18next.ts.
i18next.services.formatter?.add('lowercase', value => {
  return value.toLowerCase();
});